<template>
  <div>
    <!-- IMPLEMENTATION -->
    <div class="row mb-2">
      <div class="col">
        <div class="mb-2">
          <label
            :class="isFieldRequired('command', formConfig.requiredFields)"
            for="newIndexerCommand"
            class="form-label"
          >
            {{ $t('indexers.form.implementation.label') }}
          </label>
          <b-overlay
            :show="loadingIndexerTypes"
            variant="light"
            opacity="0.6"
            spinner-type="grow"
            :spinner-small="true"
          >
            <ValidationProvider
              v-slot="{ classes, errors }"
              ref="command"
              :rules="isFieldRequired('command', formConfig.requiredFields)"
            >
              <div
                class="control"
                :class="classes"
              >
                <Multiselect
                  v-model="form.command"
                  :options="indexersTypes"
                  track-by="value"
                  label="label"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  :searchable="false"
                  :placeholder="$t('indexers.form.implementation.placeholder')"
                />
                <span class="form-errors">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </b-overlay>
        </div>
      </div>
    </div>
    <!-- NAME -->
    <div class="row mb-2">
      <div class="col">
        <div class="mb-2">
          <label
            :class="isFieldRequired('name', formConfig.requiredFields)"
            for="newIndexerName"
            class="form-label"
          >
            {{ capitalizeFirstLetter($t('indexers.form.name.label')) }}
          </label>
          <ValidationProvider
            v-slot="{ classes, errors }"
            ref="name"
            :rules="isFieldRequired('name', formConfig.requiredFields)"
          >
            <div
              class="control"
              :class="classes"
            >
              <input
                id="newIndexerName"
                v-model="form.name"
                type="text"
                class="form-control"
                :placeholder="capitalizeFirstLetter($t('words.name'))"
              >
              <span class="form-errors">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <div
            id="indexerNameHelpBlock"
            class="form-text"
          >
            {{ $t('indexers.form.name.help') }}
          </div>
        </div>
      </div>
    </div>
    <!-- DESCRIPTION -->
    <div class="row mb-2">
      <div class="col">
        <div class="mb-2">
          <label
            for="newIndexerDescription"
            class="form-label"
          >
            Description
          </label>
          <textarea
            v-model="form.description"
            v-sanitize
            class="control form-control"
            rows="3"
          />
          <div
            id="indexerDescriptionHelpBlock"
            class="form-text"
          >
            {{ $t('indexers.form.description.help') }}
          </div>
        </div>
      </div>
    </div>
    <!-- URL -->
    <div class="row mb-2">
      <div class="col">
        <div class="mb-2">
          <label
            :class="isFieldRequired('url', formConfig.requiredFields)"
            for="newIndexerUrl"
            class="form-label"
          >
            {{ $t('indexers.form.url.label') }}
          </label>
          <ValidationProvider
            v-slot="{ classes, errors }"
            ref="url"
            :rules="isFieldRequired('url', formConfig.requiredFields)"
          >
            <div
              class="control"
              :class="classes"
            >
              <input
                id="newIndexerUrl"
                v-model="form.url"
                type="text"
                class="form-control"
                placeholder="URL"
              >
              <span class="form-errors">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <div
            id="indexerURLHelpBlock"
            class="form-text"
          >
            {{ $t('indexers.form.url.help') }}
          </div>
        </div>
      </div>
    </div>
    <!-- ORGANISATION -->
    <div class="row mb-2">
      <div class="col">
        <div class="mb-2">
          <label
            for="newIndexerOrganisation"
            class="form-label"
          >
            {{ $t('indexers.form.organisation.label') }}
          </label>
          <ValidationProvider
            v-slot="{ classes, errors }"
            ref="url"
            :rules="isFieldRequired('organisation', formConfig.requiredFields)"
          >
            <div
              class="control"
              :class="classes"
            >
              <input
                id="newIndexerOrganisation"
                v-model="form.organisation"
                type="text"
                class="form-control"
                placeholder="Organisation"
              >
              <span class="form-errors">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <div
            id="indexerOrganisationHelpBlock"
            class="form-text"
          >
            {{ $t('indexers.form.organisation.help') }}
          </div>
          <!-- <div
            id="indexerOrganisationHelpBlock"
            class="form-text no-margin"
          >
            {{ $t('indexers.form.organisations.help') }}
          </div>
          <SearchUsergroups
            :usergroup="null"
            :types="['organisation', 'user-group']"
            :placeholder="$t('organisations.search')"
            :reset-after="true"
            :limit="10"
            @select="setUsergroup"
          />
          <div class="selected-usergroups-container">
            <div
              v-for="usergroup in selectedUsergroups"
              :key="`selected-usergroup-${usergroup.display_name}`"
              class="selected-usergroup"
            >
              {{ usergroup.display_name }}
              <div data-bs-theme="dark">
                <button
                  type="button"
                  class="btn-close btn-sm"
                  aria-label="Close"
                  @click="removeUsergroup(usergroup)"
                />
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- PATTERN -->
    <div class="row mb-2">
      <div class="col">
        <div class="mb-2">
          <label
            for="newIndexerPattern"
            class="form-label"
          >
            {{ $t('indexers.form.pattern.label') }}
          </label>
          <input
            id="newIndexerPattern"
            v-model="form.pattern"
            type="text"
            class="form-control"
            :placeholder="$t('indexers.form.pattern.placeholder')"
          >
          <div
            id="indexerPatternHelpBlock"
            class="form-text"
          >
            {{ $t('indexers.form.pattern.help') }}
          </div>
        </div>
      </div>
    </div>
    <!-- SCHEDULER -->
    <!-- <div class="row">
      <div class="col">
        <div class="mb-2">
          <label
            :class="isFieldRequired('scheduler', formConfig.requiredFields)"
            for="newIndexerScheduler"
            class="form-label"
          >
            {{ $t('resource.scheduler.label') }}
          </label>
          <b-overlay
            :show="loadingSchedulers"
            variant="light"
            opacity="0.6"
            spinner-type="grow"
            :spinner-small="true"
          >
            <ValidationProvider
              v-slot="{ classes, errors }"
              ref="scheduler"
              :rules="isFieldRequired('scheduler', formConfig.requiredFields)"
            >
              <div
                class="control"
                :class="classes"
              >
                <Multiselect
                  v-model="form.scheduler"
                  :options="schedulers"
                  track-by="id"
                  label="label"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  :searchable="false"
                  :placeholder="$t('indexers.form.scheduler.placeholder')"
                />
                <span class="form-errors">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </b-overlay>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import i18n from '@/common/i18n/i18n.js';
import _ from 'lodash';

import Multiselect from 'vue-multiselect';
// import SearchUsergroups from '@/components/Searchbars/SearchUsergroups.vue';

import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
extend('required', {
  ...required,
  message: i18n.messages[i18n.locale].words.requiredField
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'IndexerForm',

  components: {
    Multiselect,
    // SearchUsergroups,
    ValidationProvider
  },

  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      //loaders
      loadingIndexerTypes: false,
      loadingSchedulers: false,

      // form
      form: {
        name: null,
        description: null,
        url: null,
        command: null,
        organisation: null,
        forcedOrganisations: [],
        pattern: null,
        scheduler: null
      },

      // usergroups
      // selectedUsergroups: []
    };
  },

  computed: {
    ...mapState('indexers', [
      'indexersTypes'
    ]),
    // ...mapState('resources', [
    //   'schedulers'
    // ]),

    formConfig() {
      return this.$config.forms.indexer;
    },
  },

  watch: {
    data: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.form = _.cloneDeep(newValue);
          // this.selectedUsergroups = newValue.forcedOrganisations.map(el => {
          //   return {
          //     display_name: el
          //   };
          // });
        }
      }
    },
    form: {
      deep: true,
      handler(newValue) {
        this.$emit('set', newValue);
      }
    },
    // selectedUsergroups: {
    //   deep: true,
    //   handler(newValue) {
    //     this.form.forcedOrganisations = newValue.map(el => el.display_name);
    //   }
    // }
  },

  async created () {
    if (!this.indexersTypes.length || this.indexersTypes.length === 0) {
      try {
        this.loadingIndexerTypes = true;
        await this.GET_INDEXERS_TYPES();
        this.loadingIndexerTypes = false;
      } catch {
        this.loadingIndexerTypes = false;
      }
    }
    // if (!this.schedulers.length || this.schedulers.length === 0) {
    //   try {
    //     this.loadingSchedulers = true;
    //     await this.GET_SCHEDULERS();
    //     this.loadingSchedulers = false;
    //   } catch {
    //     this.loadingSchedulers = false;
    //   }
    // }
  },

  methods: {
    ...mapActions('indexers', [
      'GET_INDEXERS_TYPES'
    ]),
    // ...mapActions('resources', [
    //   'GET_SCHEDULERS'
    // ]),

    // setUsergroup(usergroup) {
    //   const index = this.selectedUsergroups.findIndex(el => el.display_name === usergroup.display_name);
    //   if (index === -1) {
    //     this.selectedUsergroups.push(usergroup);
    //   }
    // },
    // removeUsergroup(usergroup) {
    //   const index = this.selectedUsergroups.findIndex(el => el.display_name === usergroup.display_name);
    //   if (index !== -1) {
    //     this.selectedUsergroups.splice(index, 1);
    //   }
    // }
  }
};
</script>

<style lang="less" scoped>
.form-text {
  font-size: 0.8rem;
  font-style: italic;
  color: #838383;
  white-space: pre-line;
}
.no-margin {
  margin: 0;
}
input::placeholder {
  opacity: 0.6;
}
.selected-usergroups-container {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.5rem;
  .selected-usergroup {
    display: flex;
    background-color: @blue;
    color: #FFFFFF;
    margin: 0.5rem 0;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    margin-right: 0.5rem;
    line-height: 1.5rem;
    .btn-close {
      margin-left: 0.5rem;
    }
  }
}
</style>